/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@kubb/plugin-client/clients/fetch";
import type { GetDrawingPolygonFeaturesQueryResponse, GetDrawingPolygonFeaturesPathParams, GetDrawingPolygonFeatures422 } from "../models/drawingClient/GetDrawingPolygonFeatures";
import type { RequestConfig, ResponseErrorConfig } from "@kubb/plugin-client/clients/fetch";

function getGetDrawingPolygonFeaturesUrl(project_uuid: GetDrawingPolygonFeaturesPathParams["project_uuid"], file_uuid: GetDrawingPolygonFeaturesPathParams["file_uuid"]) {
  const res = { method: 'GET', url: `/v1/drawings/${project_uuid}/${file_uuid}/polygons` as const }  
  return res
}

/**
 * @description Returns redirect to a download link of a GZipped GeoJSON FeatureCollection that contains all polygon features of the specified drawing file. Each feature's geometry is described as a standard GeoJSON Polygon.
 * @summary Get polygon features for a drawing as GeoJSON feature collection
 * {@link /v1/drawings/:project_uuid/:file_uuid/polygons}
 */
export async function getDrawingPolygonFeatures(project_uuid: GetDrawingPolygonFeaturesPathParams["project_uuid"], file_uuid: GetDrawingPolygonFeaturesPathParams["file_uuid"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetDrawingPolygonFeaturesQueryResponse, ResponseErrorConfig<GetDrawingPolygonFeatures422>, unknown>({ method : "GET", url : getGetDrawingPolygonFeaturesUrl(project_uuid, file_uuid).url.toString(), ... requestConfig })  
  return res.data
}